<template>
  <Modal
    v-if="showLeavingModal"
    confirmText="Ja"
    cancelText="Avbryt"
    v-on:confirm="leave"
    size="sm"
    v-on:cancel="showLeavingModal = false"
  >
    <p>
      <span class="text-t6 block mb-4">Om du lämnar sidan kommer det du lagt in att rensas.</span>
      Vill du lämna sidan?
    </p>
  </Modal>
  <Modal v-if="showEmailModal && profile.email == ''" v-on:cancel="showEmailModal = false">
    <section>
      <h4>För att kunna göra en felanmälan behöver du lägga in din e-postadress</h4>
      <ContactInfoForm :showContact="false" @done="this.hideModal" :editProfilePreset="true" />
    </section>
  </Modal>
  <div class="col-span-full sm:col-span-full md:col-span-7 pb-8">
    <div v-if="!!webapp_config.hide_errorreport">
      <h2>{{ webapp_config.hide_errorreport_title }}</h2>
      <p v-html="webapp_config.hide_errorreport_text.replace(/\\r\\n/g, '<br />')"></p>
    </div>

    <div v-else class="flex flex-col gap-4 md:gap-8">
      <div>
        <h1 class="text-t2">Felanmälan</h1>
      </div>

      <Box class="flex flex-col gap-8">
        <div
          class="flex w-full border-b border-solid border-gray-light pb-4 mb-4 sm:mb-8 justify-between content-center"
          v-if="isConfirmationPage && Object.keys($route.query).indexOf('skickat') == -1 && !$route.path.includes('/skicka')"
        >
          <StepwizzardErrorReport activeStep="atStep" stepName="confirmation" />
          <div class="flex flex-col pt-1">
            <Button
              variant="tertiary"
              size="large"
              @click="resetErrorReportForm"
            >
              Börja om
              <template #icon-after>
                <IconReload />
              </template>
            </Button>
          </div>
        </div>

        <router-view :isDuplicate="isDuplicate" :key="$route.params.rowId"></router-view>
      </Box>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Expandable from '@/components/ui/expandable';
import ContactInfoForm from '@/components/profile/contact-info-form';
import Modal from '@/components/ui/modal';
import Box from '@/components/ui/box';
import Button from '@/components/ui/button';
import IconReload from '@/components/icons/IconReload';
import IconTrashCan from '@/components/icons/IconTrashCan';
import Loader from '@/components/ui/loader';
import StepwizzardErrorReport from "@/components/ui/StepwizzardErrorReport.vue";

export default {
  name: 'CreateErrorReport',
  components: {
    StepwizzardErrorReport,
    Box,
    Button,
    IconReload,
    IconTrashCan,
    Expandable,
    Modal,
    Loader,
    ContactInfoForm,
  },
  data() {
    return {
      isDuplicate: false,
      showLoader: true,
      showLeavingModal: false,
      showEmailModal: true,
      showInfo: false,
      step: null,
      contracts: [],
      address: null,
      addressTrimmed: null,
      editableProfile: {},
      nextMove: null,
    };
  },

  /**
   * Varnar om man lämnar sidan. Klickar man ja så tömms den felanmälan man påbörjat.
   */
  beforeRouteLeave(to, from, next) {
    if (this.rows.length && (this.rows.length > 1 || this.rows[0].areaCode)) {
      //visa modal
      this.nextMove = next;
      this.showLeavingModal = true;
    } else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to && to.name == 'ErrorReportAddNew' && this.rows && !!this.rows.length) {
      // Går till första raden.
      this.$router.replace({
        name: 'ErrorReportEditRow',
        params: { rowId: this.rows[this.rows.length - 1].id },
      });
    }

    if (to.name == 'ErrorReportConfirm' && Object.keys(to.query).indexOf('skickar') > -1) {
      this.showLoader = true;
    }

    if (
      (from.name == 'ErrorReportConfirm' && to.name != 'ErrorReportConfirm') ||
      (to.name == 'ErrorReportConfirm' && Object.keys(to.query).indexOf('skickar') == -1)
    ) {
      this.showLoader = false;
    }
    return next();
  },
  watch: {
    '$store.getters.getErrorReportRows': {
      immediate: true,
      async handler() {
        this.isDuplicate = await this.calculateIsDuplicate();
      },
    },

    '$route.params.rowId': {
      immediate: true,
      handler() {
        this.currentRowIsFinished = false;
      },
    },
    profile: {
      deep: true,
      immediate: true,
      handler(profile) {
        this.editableProfile = { ...profile };
      },
    },
  },


  computed: {
    ...mapGetters({
      webapp_config: 'webapp_config',
      profile: 'profile',
      getErrorReportsList: 'getErrorReportsList',
      contracts: 'contracts'
    }),
    isConfirmationPage() {
      return this.$route.name === 'ErrorReportConfirm';
    },
    nrOfRows() {
      return this.$store.getters.getErrorReportRows.length;
    },
    selectedRowId() {
      return this.$route.params.rowId;
    },

    rows() {
      return this.$store.getters.getErrorReportRows;
    },
    draft() {
      return this.$store.getters.getErrorReportDraft;
    },
  },
  methods: {
    async calculateIsDuplicate() {
      const currentRowId = this.nrOfRows - 1;
      const row = this.$store.getters.getErrorReportRows;
      if (!row) return false;

      const currentRow = row[currentRowId];
      if (!currentRow) return false;


      //if current error report doesn't concern an apartment
      if (
        ((currentRow.areaCode != 'apartment' ||
            !currentRow.rentalObjectCode)
        )
      )
        return false;

      if (!currentRow.partCode || !currentRow.subPartCode || !currentRow.locationCode) return false;

      this.address = await this.getAddress(currentRow.rentalObjectCode);
      //If there are no other active workorders return false
      const workorders = this.getErrorReportsList;
      const workorderArray = Object.values(workorders);

      if (!workorderArray || !workorderArray[0] || (workorderArray && workorderArray[0] && workorderArray[0].length == 0)) return false;
      //check if there is an active workorder for this address
      let found = workorderArray[0].filter(
        (item) =>
          (item.location && item.location.indexOf(this.address) > -1) &&
          item.status != 'finished',
      );

      if (found.length == 0) return false;

      //Check if earlier active error report concerns something inside the apartment
      let foundPlace = found.filter(
        (item) =>
          item.workOrderType.indexOf('apartment') > -1
      );
      if (foundPlace.length == 0) return false;

      if (
        !currentRow.locationCode
      )
        return false;

      let location = currentRow.locationCode;
      let rooms = this.$store.getters.getErrorReportAreas;

      //Loopa igenom och ta bort siffran om det bara finns 1 rum i gruppen
      let roomsFiltered =  rooms.map(room => {
        return {
          ...room,
          name: room.name.replace(/\s\d+$/, "")
        };
      });

      let roomName = roomsFiltered.filter(
        (item) =>
          item.roomTypeCode.indexOf(location) > -1
      );

      if (roomName.length == 0) return false;


      let foundLocation = foundPlace.filter(
        (item) =>
          item.categoryThree.indexOf(roomName[0].name) > -1
      );
      if (foundLocation.length == 0) return false;

      let parts = this.$store.getters.getSubCategories;
      let part = currentRow.partCode;


      if (!parts || parts.length == 0) return false;
      let partName = parts.filter(
        (item) =>
          item && item.id == part
      );
      if (partName.length == 0) return false;


      let foundPart = foundLocation.filter(
        (item) =>
          item.title.indexOf(partName[0].name) > -1
      );
      if (foundPart.length == 0) return false;


      let subparts = this.$store.getters.getSubParts;
      let subpart = currentRow.subPartCode;


      if (!subpart || subparts.length == 0) return false;
      let subpartName = subparts.filter(
        (item) =>
          item && item.id == subpart
      );
      if (subpartName.length == 0) return false;


      let foundSubPart = foundPart.filter(
        (item) =>
          item.title.indexOf(subpartName[0].name) > -1
      );
      if (foundSubPart.length == 0) return false;

      return true;
    },
    resetErrorReportForm() {
      // Get all current rows
      const currentRows = this.$store.getters.getErrorReportRows;
      if (currentRows && currentRows.length > 0) {
        // Create a new error report draft, which resets everything
        this.$store.dispatch('createErrorReportDraft').then(() => {
          // Then create a new row and navigate to it
          // this.pushNewRow();
          this.$router.push({ path: '/felanmalan' });

        });
      }
    },


    async getAddress(contract) {
      let contracts = await this.$store.cache.dispatch("fetchApartmentContracts", 'apartment');
      return contracts.find(c => c.value === contract)?.name || null;
    },

    leave() {
      this.$store.dispatch('createErrorReportDraft').then(() => {
        this.nextMove();
      });
    },

    deleteRow(rowId) {
      return this.$store.dispatch('deleteErrorReportRow', rowId).then(() => {
        this.$router.push({
          name: 'ErrorReportEditRow',
          params: {
            rowId:
              this.$store.getters.getErrorReportRows[
                this.$store.getters.getErrorReportRows.length - 1
              ].id,
          },
        });
      });
    },

    pushNewRow() {
      return this.$store.dispatch('newErrorReportRow').then((newRowId) => {
        this.$router.push({
          name: 'ErrorReportEditRow',
          params: { rowId: newRowId, step: 'vart-ar-felet' },
        });
      });
    },
    hideModal() {
      this.showEmailModal = false;
      document.querySelector('html').classList.remove('modal-open');
    },

  },
  updated() {
    const el = document.querySelector('.report-form');
    if (el && el.offsetTop != null) {
      window.scrollTo({
        top: el.offsetTop - 70,
        behavior: 'smooth',
      });
    }
  },
  created() {
    this.showLoader = true;

    // Skrolla alltid till toppen
    window.scroll(0, 0);

    return Promise.all([
      this.$store.cache.dispatch('fetchProfile'),
      this.$store.cache.dispatch('fetchContracts'),
    ]).finally(() => {
      this.$store.cache.dispatch('fetchBaseCategories', this.$store.getters.getContracts).then((d) => {
        this.$store.cache.dispatch('fetchProfile').then((data) => {
          this.$store.cache.dispatch('fetchErrorReportsList', data.contactCode).finally(() => {
            this.showLoader = false;
          });
        });
      });


      /**
       * Finns inget draft skapas en
       */
      if (
        !this.$store.getters.getErrorReportDraft ||
        this.$store.getters.getErrorReportRows.length == 0
      ) {
        this.$store.dispatch('createErrorReportDraft').then(() => {
          this.pushNewRow();
        });
      } else {
        // Går till första raden.
        this.$router.push({
          name: 'ErrorReportEditRow',
          params: {
            rowId:
              this.$store.getters.getErrorReportRows[
                this.$store.getters.getErrorReportRows.length - 1
              ].id,
          },
        });
      }
    });
  },
};
</script>
